export const DESKTOP_LOAD_LIMIT = 30;
